import useTableRequest from "../../hooks/useTableRequest";
import { useEffect, useState } from "react";
import Table from "../../components/common/table/Table";
import Title from "../../components/common/title/Title";
import { vendorProductListColumns } from "../../constant/tables-columns/tablesColums";
import Pagination from "../../components/common/pagination/Pagination";
import { useNavigate } from "react-router";
import { publicImageProps } from "../../services/config";
import { digitsThree } from "../../utils/price";
import DefaultImage from "../../components/common/default-image/DefaultImage";
import VendorProductFilter from "./VendorProductFilter";

export default function VendorProductList() {
  const tableRequest = useTableRequest({ initialLoading: true });
  const [productData, setProductData] = useState([]);
  const [pagination, setPagination] = useState(null);

  const getProduct = async (params) => {
    const path = "admin/vendorStoresProducts";
    return tableRequest.load({ path, params: { ...params } }, (response) => {
      setProductData(response?.data?.result.data);
      setPagination(response?.data?.result);
    });
  };

  useEffect(() => {
    getProduct({});
  }, []);

  const [filter, setFilter] = useState();

  const filterDataHandler = (newParams) => {
    setFilter({ ...filter, ...newParams });
    const allFilter = {
      ...filter,
      ...newParams,
    };
    console.log("filter", allFilter);
    getProduct(allFilter);
  };

  const data = [];

  productData?.map((item) =>
    data.push({
      ...item,
      key: item._id,
      id: item._id,
      basePrice: `${digitsThree(item.basePrice)}`,
      showDiscountPercent: `${item.discountPercent}%` || 0,
      showMainImage: item.mainImage ? (
        <img
          className="w-10 h-10 rounded-md"
          {...publicImageProps(item.mainImage, { vendor: true, variant: "thumb_" })}
        />
      ) : (
        <DefaultImage imgSize={26} imgClass={"!w-10 !h-10 rounded-md"} />
      ),
      faStatus:
        item.status === "active"
          ? "فعال"
          : item.status === "pending"
          ? "انتظار"
          : "غیرفعال",
    })
  );

  const navigate = useNavigate();

  const shoeVendorProduct = (singleProduct) => {
    const newSingleProduct = productData.filter((item) => {
      return item._id == singleProduct.id;
    });
    console.log(newSingleProduct);
    navigate("/show-vendor-product", { state: newSingleProduct[0] });
  };

  return (
    <div className="bg-white dark:bg-gray-900 rounded-3xl p-6">
      <Title title={"لیست محصولات غرفه"} />
      <VendorProductFilter filterDataHandler={filterDataHandler} />
      <Pagination
        filterDataHandler={filterDataHandler}
        pagination={pagination}
      />
      <Table loading={tableRequest.loading} error={tableRequest.error} idle={tableRequest.status === "idle"} onRetry={tableRequest.retry}
        columns={vendorProductListColumns}
        rows={data}
        onShow={shoeVendorProduct}
      />

      <Pagination
        pagination={pagination}
        filterDataHandler={filterDataHandler}
      />
    </div>
  );
}
